const LiRedo = ({t, onClick}) => (
    <li onClick={onClick} className={"redo"}>
    <span className={"clickable"}>
        <span className="sub-title"><ion-icon name="arrow-redo-outline" /></span>
        <span className="title">{t("navigationBook.book.return")}</span>
    </span>
</li>)

export default LiRedo;
